"use client";

import React from "react";
import { useEffect, useState } from "react";
// import { Link } from 'react-router-dom';
// import { HomeDetail } from "../services/HomeDetail";
import Link from "next/link";
import { useDispatch } from "react-redux";
import {
  setInquiryPopup,
  setInquiryPopupObj,
} from "@/store/slices/inquirySlice";
import Image from "next/image";
// import Seo from "../components/Seo";

export default function Home({
  // inquiryPopupObj,
  // setInquiryPopupObj,
  // inquiryPopup,
  // setInquiryPopup,
  //   homeDetailsData,
  propertylist,
  completedPropertylist,
}) {
  const [isMobilescreen, setMobileScreen] = useState(false);
  //   const [homeDetailsData, setHomeDetail] = useState(homeDetails || null);

  useEffect(() => {
    if (window.innerWidth <= 767) {
      setMobileScreen(true);
    }
    // if (!homeDetailsData) {

    // }
  }, []);

  const dispatch = useDispatch();

  //   const seoMetaData = homeDetailsData && {
  //     page_title:
  //       homeDetailsData.page_title ||
  //       "Swati Procon - Luxury Residential & Commercial Projects in Ahmedabad",
  //     page_description:
  //       homeDetailsData.page_description ||
  //       "Discover premium residential and commercial projects by Swati Procon, designed with innovation, quality, and sustainability in mind. Explore our ongoing, upcoming, and completed projects in Ahmedabad.",
  //     page_keywords:
  //       homeDetailsData.page_keywords ||
  //       "Swati Procon, luxury apartments, commercial spaces, real estate Ahmedabad, premium projects, residential buildings, office spaces, retail spaces",
  //     slug: "/",
  //     image: homeDetailsData.page_image_full
  //       ? homeDetailsData.page_image_full.includes("?")
  //         ? `${homeDetailsData.page_image_full}&w=1280&h=640`
  //         : `${homeDetailsData.page_image_full}?w=1280&h=640`
  //       : "/images/sswati-procon.png",
  //   };

  //   if (!homeDetailsData) {
  //     return <div>Error loading data</div>;
  //   }

  return (
    <>
      {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}

      <div
        className="reecosys-template-page-wrapper"
        id="home-page-wrapper-reecosys-template"
        style={{ minHeight: "100vh" }}
      >
        {propertylist.length > 0 && (
          <section
            className="reecosys-template-section section-padding relative"
            id="reecosys-template-home-section-3"
          >
            <div className="list-grid-block main-container active">
              <div className="inner-flex inner-flex-medium">
                <div className="inner-flex inner-flex-medium">
                  <div className="tab-projects-flex-wrapper">
                    <div className="section-title wfc  relative">
                      <h2
                        className="uppercase "
                        data-aos="fade-in"
                        data-aos-delay="300"
                        data-aos-duration="1000"
                      >
                        Ongoing
                      </h2>
                    </div>
                  </div>
                  <div className="project-list-grid project-list-grid-2-column">
                    {propertylist
                      .filter(
                        (project_list_data) =>
                          project_list_data.status !== "pre launching",
                      )
                      .map((project_list_data, index) => (
                        <div key={index} className="project-list-card relative">
                          <div
                            className="relative"
                            data-aos="fade-up"
                            data-aos-delay="400"
                            data-aos-duration={`${index + 3}00`}
                          >
                            <Link
                              href={project_list_data.slug}
                              className="inner-flex"
                            >
                              <div className="relative">
                                <div
                                  className="project-img-list overflow relative"
                                  style={{ aspectRatio: "1080 / 844" }}
                                >
                                  <Image
                                    src={`${project_list_data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                    alt={
                                      project_list_data.project_title ||
                                      "project"
                                    }
                                    fill
                                    className=""
                                  />

                                  {project_list_data.status && (
                                    <div
                                      className={`status-lable status-${project_list_data.status
                                        .toLowerCase()
                                        .replace(/\s+/g, "-")}`}
                                    >
                                      <p className="text-uppercase">
                                        {project_list_data.status}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="project-info-list">
                                <div className="inner-flex inner-flex-smallest">
                                  <div className="section-paragraph flex-row j-c-sb alc">
                                    <h2 className="text-uppercase charter_regular">
                                      {project_list_data.project_title}
                                    </h2>
                                  </div>

                                  <div className="flex-row alc j-c-sb">
                                    <div className="flex-row alc flex-mb-clm inner-flex-smallest projectHomeSpecs">
                                      {project_list_data.size_price && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <Image
                                              src="/images/icon/building.svg"
                                              alt="reecosys"
                                              width={20}
                                              height={20}
                                            />
                                          </div>
                                          <div className="section-textpara banner-detail-row-grid-text">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.size_price}
                                            </p>
                                          </div>
                                        </div>
                                      )}

                                      {project_list_data.location && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <Image
                                              src="/images/icon/location.svg"
                                              alt="reecosys"
                                              width={20}
                                              height={20}
                                            />
                                          </div>
                                          <div className="section-textpara">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.location}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>

                            <div className="projectListingBtn">
                              <button
                                className={`reecosys-template-button button-style-secondary ${
                                  isMobilescreen ? "w100" : ""
                                }`}
                                onClick={() => {
                                  (dispatch(setInquiryPopup(true)),
                                    dispatch(setInquiryPopupObj(project)));
                                }}
                              >
                                <span className="material-symbols-outlined">
                                  chat
                                </span>
                                <p className="capitalize">Inquire Now</p>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                <div className="inner-flex inner-flex-medium">
                  <div className="tab-projects-flex-wrapper">
                    <div className="section-title section-padding-small pb0 wfc  relative">
                      <h2
                        className="uppercase "
                        data-aos="fade-in"
                        data-aos-delay="300"
                        data-aos-duration="1000"
                      >
                        Completed
                      </h2>
                    </div>
                  </div>
                  <div className="project-list-grid project-list-grid-2-column">
                    {completedPropertylist
                      .filter(
                        (project_list_data) =>
                          project_list_data.status !== "pre launching",
                      )
                      .map((project_list_data, index) => (
                        <div key={index} className="project-list-card relative">
                          <div
                            className="relative"
                            data-aos="fade-up"
                            data-aos-delay="400"
                            data-aos-duration={`${index + 3}00`}
                          >
                            <Link
                              href={project_list_data.slug}
                              className="inner-flex"
                            >
                              <div className="relative">
                                <div
                                  className="project-img-list overflow relative"
                                  style={{ aspectRatio: "1080 / 844" }}
                                >
                                  <Image
                                    src={`${project_list_data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                    alt={
                                      project_list_data.project_title ||
                                      "project"
                                    }
                                    fill
                                    className=""
                                  />

                                  {project_list_data.status && (
                                    <div
                                      className={`status-lable status-${project_list_data.status
                                        .toLowerCase()
                                        .replace(/\s+/g, "-")}`}
                                    >
                                      <p className="text-uppercase">
                                        {project_list_data.status}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="project-info-list">
                                <div className="inner-flex inner-flex-smallest">
                                  <div className="section-paragraph flex-row j-c-sb alc">
                                    <h2 className="text-uppercase charter_regular">
                                      {project_list_data.project_title}
                                    </h2>
                                  </div>

                                  <div className="flex-row alc j-c-sb">
                                    <div className="flex-row alc flex-mb-clm inner-flex-smallest projectHomeSpecs">
                                      {project_list_data.size_price && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <Image
                                              src="/images/icon/building.svg"
                                              alt="reecosys"
                                              width={20}
                                              height={20}
                                            />
                                          </div>
                                          <div className="section-textpara banner-detail-row-grid-text">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.size_price}
                                            </p>
                                          </div>
                                        </div>
                                      )}

                                      {project_list_data.location && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <Image
                                              src="/images/icon/location.svg"
                                              alt="reecosys"
                                              width={20}
                                              height={20}
                                            />
                                          </div>
                                          <div className="section-textpara">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.location}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>

                            <div className="projectListingBtn">
                              <button
                                className={`reecosys-template-button button-style-secondary ${
                                  isMobilescreen ? "w100" : ""
                                }`}
                                onClick={() => {
                                                                 (dispatch(setInquiryPopup(true)),
                                                                   dispatch(setInquiryPopupObj(project)));
                                                               }}  
                              >
                                <span className="material-symbols-outlined">
                                  chat
                                </span>
                                <p className="capitalize">Inquire Now</p>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              {/* <div className="view-all-projects-btn-home">
                <Link href="projects">
                  <button className="reecosys-template-button button-style-secondary">
                    <p>View All</p>
                  </button>
                </Link>
              </div> */}
            </div>
          </section>
        )}

        {/* <section
          className="section-padding"
          style={{ backgroundColor: "#2e2f2f" }}
        >
          <div className="section-title section-padding-small pt0">
            <h2 className="white-color text-center">Social Initiative</h2>
          </div>
          <div className="socialInitiativeImg overflow">
            <img
              loading="lazy"
              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/home/initiative.svg"
              className="hide-tab-mobile"
              alt="Social Initiative Image"
            />
            <img
              loading="lazy"
              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/home/initiative-mob.svg"
              className="visible-tab-mobile"
              alt="Social Initiative Image"
            />
          </div>
        </section> */}
      </div>
    </>
  );
}
